import React, { useContext } from 'react';
import RequestContext from '../../../fgs/context/RequestContext';
import { RESOURCES_BASE_URL } from "../../../services/api";
import { formatPathForResources } from "../../../services/urlParams";

const NOT_FOUND = 'WebGis não encontrado para o usuário';

export const WebGisPage = () => {
  const requestContext = useContext(RequestContext);
  const loggedUser = requestContext.loggedUser;

  if (loggedUser) {
    if (loggedUser.webGisPath) {
      return <iframe
        className="resources-iframe"
        src={`${RESOURCES_BASE_URL}${formatPathForResources(loggedUser.webGisPath)}`} />;
    }

    return <span>{NOT_FOUND}</span>;
  }

  return (
    <span>{NOT_FOUND}</span>
  );
};